module.exports = __webpack_public_path__ + "img/limpiar.527f952e.svg";